import Vue from 'vue'
import md5 from 'js-md5';
import vue from "../main";

// 时间戳转时间 now：当前时间  type:1 年月日时分秒  else
function ZHDate(now, type) {
  let year = now.getYear()
  let month = now.getMonth() + 1
  let date = now.getDate()
  let hour = now.getHours()
  let minute = now.getMinutes()
  let second = now.getSeconds()
  if (type == 1) {
    return "20" + year.toString().slice(1, 3) + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type == 2) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type == 6) {
    return "20" + year.toString().slice(1, 3) + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type == 8) {
    return "20" + year.toString().slice(1, 3)
  } else if (type == 4) {
    return  getzf(month) + "/" + getzf(date)
  } else {
    return "20" + year.toString().slice(1, 3) + "-" + getzf(month) + "-" + getzf(date)
  }
}
//时间转为刚刚，几分钟前，几小时前，几天前
function setDate(dateTimeStamp) {  // dateTimeStamp 时间戳
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  // let halfamonth = day * 15
  let month = day * 30
  if (dateTimeStamp == undefined) {
    return false
  } else {
    let sTime = dateTimeStamp
    let now = new Date().getTime()//获取当前时间的时间戳
    let diffValue = now - sTime
    if (diffValue < 0) {
      console.log("结束日期不能小于开始日期！")
    }
    let monthC = diffValue / month;
    let weekC = diffValue / (7 * day);
    let dayC = diffValue / day;
    let hourC = diffValue / hour;
    let minC = diffValue / minute;

    if (monthC >= 1) {
      console.log(dateTimeStamp)
      return ZHDate(new Date(dateTimeStamp))
    } else if (weekC >= 1) {
      return parseInt(weekC) + "周前"
    } else if (dayC >= 1) {
      return parseInt(dayC) + "天前"
    } else if (hourC >= 1) {
      return parseInt(hourC) + "个小时前"
    } else if (minC >= 1) {
      return parseInt(minC) + "分钟前"
    } else {
      return "刚刚"
    }
  }

}
function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}

function goBack() {
  vue.$router.go(-1)
}

function getQueryString(name){
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}
function keywordscolorful(str, key){
  var reg = new RegExp("(" + key + ")", "g");
  var newstr = str.replace(reg, "<font style='color:#c60009;'>$1</font>");
  return newstr;
}
function removeWordXml(text){
  // Remove all SPAN tags
  var html = text
  // var editor = this.editor;
  html = html.replace(/<xml>[\s\S]*?<\/xml>/ig, '');
  html = html.replace(/<style>[\s\S]*?<\/style>/ig, '');
  html = html.replace(/<\/?[^>]*>/g, '');
  html = html.replace(/[ | ]*\n/g, '\n');
  html = html.replace(/&nbsp;/ig, '');
  // editor.txt.html(html);


  html = html.replace(/[ | ]*\n/g,'');
  html = html.replace(/n[s| | ]*r/g,'');
  html = html.replace(/<o:p> <\/o:p>/g,"");
  html = html.replace(/<?SPAN[^>]*>/g,"");

  return html;
}

const tools = {
  ZHDate,
  goBack,
  setDate,
  getQueryString,
  keywordscolorful,
  removeWordXml
}

Vue.prototype.$md5 = md5;
Vue.prototype.$tools = tools;

